import React from "react";

import { ModalBody } from "./Modal";

import "./style/_script-install-modal.scss";

const ScriptInstallModal = (props) => {
    const { handleCloseModal } = props;

    return (
        <ModalBody id="scriptInstallModalContent" $title>
            <div className="iv_txt">
                {props.modalType == "scriptDelete" ? (
                    <>
                        <ul>
                            <li>
                                <span>1</span>
                                <p>
                                    업데이트 이후 배너 생성&수정시에 스크립트가
                                    자동으로 생성됩니다.
                                </p>
                            </li>
                            <li>
                                <span>2</span>
                                <p>
                                    배너 수정 후 배너가 이중으로 노출 된다면
                                    디자인 편집 &gt; 레이아웃 &gt; 공통 레이아웃
                                    내에 있는 기존 스크립트를 꼭 삭제 해주세요
                                </p>
                            </li>
                            <li>
                                <span>3</span>
                                <p>기존 스크립트 형식은 다음과 같습니다.</p>
                            </li>
                        </ul>
                        <div className="close-btn">
                            <button type="button" onClick={handleCloseModal}>
                                위 사항을 모두 확인하였으며 적용하였습니다.
                            </button>
                        </div>
                    </>
                ) : (
                    <ul>
                        <li>
                            <span>STEP 1</span>
                            <p>
                                배너 생성 및 수정시 자동적으로 스크립트가 적용
                                됩니다.
                            </p>
                        </li>
                        <li>
                            <span>STEP 2</span>
                            <p>
                                해당 배너가 노출되지 않는다면 페이지에 배너
                                코드가 입력되었는지 확인해주세요.(배너 그룹관리
                                &gt; 코드복사 &gt; 페이지 입력)
                            </p>
                        </li>
                        <li>
                            <span>STEP 3</span>
                            <p>
                                상품 상세정보에 배너를 노출 할 때에는 상품 상세
                                페이지에 배너 코드 입력 후 카테고리 혹은 상품
                                연결이 되어있어야 합니다.
                            </p>
                        </li>
                        <li>
                            <span>STEP 4</span>
                            <p>
                                배너가 보이지 않을 경우 배너 수정 &gt; 저장을
                                통해 스크립트를 업데이트 해주세요.
                            </p>
                        </li>
                        <li>
                            <span>STEP 5</span>
                            <p>
                                커스텀 배너 사용시 아래 안내되는 ‘소스’가 ‘커스텀 배너 실행 페이지’에 입력되어야 정상적인 사용이 가능합니다.
                            </p>
                        </li>
                    </ul>
                )}
            </div>
            {props.modalType == "scriptDelete" ? (
                <div className="script_wrap">
                    <textarea
                        readOnly
                        name=""
                        id=""
                        className="script_in"
                        value={props?.script_src}
                    ></textarea>
                </div>
            ) : (
                ""
            )}
            {props.modalType == "scriptInstall" ? (
                <div className="script_wrap">
                    <textarea
                        readOnly
                        name=""
                        id=""
                        className="script_guide"
                        value={props.install_src}
                    ></textarea>
                </div>
            ) : (
                ""
            )}
        </ModalBody>
    );
};

export default ScriptInstallModal;
